import { EventEmitter, SimpleChanges } from '@angular/core';
import { Router } from "@angular/router";
import { WellbeingResultDetailsComponent } from '../../../../shared/wellbeing-result/wellbeing-result-details/wellbeing-result-details.component';
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import * as i0 from "@angular/core";
import * as i1 from "@angular/router";
import * as i2 from "@ng-bootstrap/ng-bootstrap";
import * as i3 from "../../../../ng-jhipster/language/jhi-translate.directive";
import * as i4 from "@angular/common";
import * as i5 from "@fortawesome/angular-fontawesome";
import * as i6 from "../../../../shared/wellbeing-result/wellbeing-result-badge/wellbeing-result-badge.component";
function InukaJourneyCoachChatComponent_tr_14_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 12);
    i0.ɵɵelementStart(2, "div", 13);
    i0.ɵɵelement(3, "fa-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "hr", 15);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "div", 16);
    i0.ɵɵelement(7, "span", 17);
    i0.ɵɵelementStart(8, "div", 18);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r0 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 1, ctx_r0.startedSession.sessionStartTime.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
function InukaJourneyCoachChatComponent_tr_15_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr");
    i0.ɵɵelementStart(1, "td", 12);
    i0.ɵɵelementStart(2, "div", 19);
    i0.ɵɵelement(3, "fa-icon", 14);
    i0.ɵɵelementEnd();
    i0.ɵɵelement(4, "hr", 20);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td");
    i0.ɵɵelementStart(6, "div", 21);
    i0.ɵɵelement(7, "span", 22);
    i0.ɵɵelementStart(8, "div", 18);
    i0.ɵɵtext(9);
    i0.ɵɵpipe(10, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵadvance(9);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(10, 1, ctx_r1.upcomingSession.sessionStartTime.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
function InukaJourneyCoachChatComponent_tr_16_div_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13);
    i0.ɵɵelement(1, "fa-icon", 37);
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_1_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 41);
    i0.ɵɵelement(1, "use", 42);
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_2_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 43);
    i0.ɵɵelement(1, "use", 44);
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelementStart(0, "svg", 43);
    i0.ɵɵelement(1, "use", 45);
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_div_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 38);
    i0.ɵɵtemplate(1, InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_1_Template, 2, 0, "svg", 39);
    i0.ɵɵtemplate(2, InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_2_Template, 2, 0, "svg", 40);
    i0.ɵɵtemplate(3, InukaJourneyCoachChatComponent_tr_16_div_3__svg_svg_3_Template, 2, 0, "svg", 40);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.item.type === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.item.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.item.type === "intro_call");
} }
function InukaJourneyCoachChatComponent_tr_16_hr_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "hr", 15);
} }
function InukaJourneyCoachChatComponent_tr_16_span_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 46);
    i0.ɵɵtext(1, "Anonymous chat");
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_span_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 47);
    i0.ɵɵtext(1, "Video call");
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_span_9_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 48);
    i0.ɵɵtext(1, "Intro call");
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_span_10_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "span", 49);
    i0.ɵɵtext(1, "Self scan");
    i0.ɵɵelementEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_a_12_Template(rf, ctx) { if (rf & 1) {
    const _r20 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 50);
    i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_tr_16_a_12_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r20); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r18 = i0.ɵɵnextContext(); return ctx_r18.showSrqCompletedDetails(item_r3.item); });
    i0.ɵɵelement(1, "wellbeing-result-badge", 51);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = i0.ɵɵnextContext().$implicit;
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("wellbeingResult", item_r3.item);
} }
function InukaJourneyCoachChatComponent_tr_16_ng_container_13_Template(rf, ctx) { if (rf & 1) {
    const _r24 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementContainerStart(0);
    i0.ɵɵelementStart(1, "div", 52);
    i0.ɵɵelementStart(2, "a", 53);
    i0.ɵɵtext(3, "View Session");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(4, "div", 54);
    i0.ɵɵelementStart(5, "button", 55);
    i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_tr_16_ng_container_13_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r24); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r22 = i0.ɵɵnextContext(); return ctx_r22.sessionSelectedToOpenInNewTab.emit(item_r3.item); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(6, "button", 56);
    i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_tr_16_ng_container_13_Template_button_click_6_listener() { i0.ɵɵrestoreView(_r24); const item_r3 = i0.ɵɵnextContext().$implicit; const ctx_r25 = i0.ɵɵnextContext(); return ctx_r25.sessionSelectedToOpenInThisTab.emit(item_r3.item); });
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementContainerEnd();
} }
function InukaJourneyCoachChatComponent_tr_16_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "tr", 23);
    i0.ɵɵelementStart(1, "td", 24);
    i0.ɵɵtemplate(2, InukaJourneyCoachChatComponent_tr_16_div_2_Template, 2, 0, "div", 25);
    i0.ɵɵtemplate(3, InukaJourneyCoachChatComponent_tr_16_div_3_Template, 4, 3, "div", 26);
    i0.ɵɵtemplate(4, InukaJourneyCoachChatComponent_tr_16_hr_4_Template, 1, 0, "hr", 27);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(5, "td", 28);
    i0.ɵɵelementStart(6, "div", 29);
    i0.ɵɵtemplate(7, InukaJourneyCoachChatComponent_tr_16_span_7_Template, 2, 0, "span", 30);
    i0.ɵɵtemplate(8, InukaJourneyCoachChatComponent_tr_16_span_8_Template, 2, 0, "span", 31);
    i0.ɵɵtemplate(9, InukaJourneyCoachChatComponent_tr_16_span_9_Template, 2, 0, "span", 32);
    i0.ɵɵtemplate(10, InukaJourneyCoachChatComponent_tr_16_span_10_Template, 2, 0, "span", 33);
    i0.ɵɵelementStart(11, "div", 34);
    i0.ɵɵtemplate(12, InukaJourneyCoachChatComponent_tr_16_a_12_Template, 2, 1, "a", 35);
    i0.ɵɵtemplate(13, InukaJourneyCoachChatComponent_tr_16_ng_container_13_Template, 7, 0, "ng-container", 10);
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(14, "div", 36);
    i0.ɵɵtext(15);
    i0.ɵɵpipe(16, "date");
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const item_r3 = ctx.$implicit;
    const i_r4 = ctx.index;
    const ctx_r2 = i0.ɵɵnextContext();
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r3.type !== "session");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "session");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", i_r4 !== ctx_r2.displayList.length - 1);
    i0.ɵɵadvance(2);
    i0.ɵɵclassProp("pt-1", item_r3.type === "session");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "session" && item_r3.item.type === "text");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "session" && item_r3.item.type === "video");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "session" && item_r3.item.type === "intro_call");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "scan");
    i0.ɵɵadvance(2);
    i0.ɵɵproperty("ngIf", item_r3.type === "scan");
    i0.ɵɵadvance(1);
    i0.ɵɵproperty("ngIf", item_r3.type === "session");
    i0.ɵɵadvance(2);
    i0.ɵɵtextInterpolate1(" ", i0.ɵɵpipeBind2(16, 12, item_r3.date.toDate(), "HH:mm, d MMM yyyy"), " ");
} }
export class InukaJourneyCoachChatComponent {
    constructor(router, modalService) {
        this.router = router;
        this.modalService = modalService;
        this.sessionSelectedToOpenInNewTab = new EventEmitter();
        this.sessionSelectedToOpenInThisTab = new EventEmitter();
        this.selectedTab = 'all';
        this.selectedRow = 0;
        this.allList = [];
        this.sessionList = [];
        this.scanList = [];
        this.displayList = [];
        this.hasAnySelfScan = true;
        this.hasAnySession = true;
        this.modalOptions = { windowClass: 'modal-window', size: 'lg', centered: true };
    }
    ngOnInit() {
    }
    ngOnChanges(changes) {
        this.allList = [];
        this.sessionList = [];
        this.scanList = [];
        this.displayList = [];
        if (this.sessions) {
            this.completedSessions = this.sessions.filter(s => s.completed);
            this.upcomingSession = this.sessions.find(s => s.future);
            this.startedSession = this.sessions.find(s => s.active);
            this.hasAnySession = this.completedSessions.length > 0 || this.upcomingSession != null;
            for (let i = 0; i < this.completedSessions.length; i++) {
                this.allList.push({
                    date: this.completedSessions[i].sessionStartTime,
                    type: 'session',
                    item: this.completedSessions[i]
                });
            }
        }
        if (this.srqHistory) {
            this.hasAnySelfScan = this.srqHistory.length > 0;
            for (let i = 0; i < this.srqHistory.length; i++) {
                this.allList.push({ date: this.srqHistory[i].dateTaken, type: 'scan', item: this.srqHistory[i] });
            }
            this.allList.sort((a, b) => {
                if (a.date.isAfter(b.date))
                    return -1;
                if (b.date.isAfter(a.date))
                    return 1;
                else
                    return 0;
            });
        }
        this.sessionList = this.allList.filter(item => item.type === 'session');
        this.scanList = this.allList.filter(item => item.type === 'scan');
        this.displayList = this.allList;
    }
    changeTab(selectedTab, selectedList) {
        this.selectedTab = selectedTab;
        this.displayList = selectedList;
    }
    showSrqCompletedDetails(srqCompleted) {
        this.srqCompletedDetailsModalReference = this.modalService.open(WellbeingResultDetailsComponent, {
            backdrop: false,
            size: "lg",
            windowClass: "self-scan-details-modal"
        });
        this.srqCompletedDetailsModalReference.componentInstance.srqHistory = this.srqHistory;
        this.srqCompletedDetailsModalReference.componentInstance.selectedSrq = srqCompleted;
    }
}
InukaJourneyCoachChatComponent.ɵfac = function InukaJourneyCoachChatComponent_Factory(t) { return new (t || InukaJourneyCoachChatComponent)(i0.ɵɵdirectiveInject(i1.Router), i0.ɵɵdirectiveInject(i2.NgbModal)); };
InukaJourneyCoachChatComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: InukaJourneyCoachChatComponent, selectors: [["inuka-journey-coach-chat"]], inputs: { sessions: "sessions", srqHistory: "srqHistory" }, outputs: { sessionSelectedToOpenInNewTab: "sessionSelectedToOpenInNewTab", sessionSelectedToOpenInThisTab: "sessionSelectedToOpenInThisTab" }, features: [i0.ɵɵNgOnChangesFeature], decls: 17, vars: 8, consts: [[1, "card", "m-0", "p-0"], [1, "card-body", "p-0", "px-3"], [1, "row", "justify-content-between"], [1, "col", "text-left"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.all", 1, "select-tab", 3, "ngClass", "click"], [1, "select-tab"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.sessions", 1, "select-tab", 3, "ngClass", "click"], ["role", "button", "jhiTranslate", "inukaNgApp.inukaJourney.scans", 1, "select-tab", 3, "ngClass", "click"], [1, "table-responsive", "pt-4"], [1, "journey-table"], [4, "ngIf"], ["role", "button", 4, "ngFor", "ngForOf"], [1, "journey-row-icon"], [1, "circle"], ["icon", "bell"], [1, "icon-connector"], [1, "pl-2", "pt-1", 2, "margin-top", "-2.5rem"], ["jhiTranslate", "inukaNgApp.inukaJourney.sessionStarted", 1, "mr-2", "text-main"], [1, "text-light", "d-lg-inline-block", "float-lg-right"], [1, "circle-light"], [1, "icon-connector", "icon-connector-light"], [1, "pl-2", "pt-1", 2, "margin-top", "-2.3rem"], ["jhiTranslate", "inukaNgApp.inukaJourney.upcomingSession", 1, "mr-2", "text-main"], ["role", "button"], [1, "journey-row-icon", "p-0"], ["class", "circle", 4, "ngIf"], ["class", "circle-white", 4, "ngIf"], ["class", "icon-connector", 4, "ngIf"], [1, "p-0", 2, "vertical-align", "top"], [1, "pl-2", "py-0", "pt-1", 2, "margin-top", "-0.5rem"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.anonymousChat", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.videoCall", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "sessionSchedule.paragraph.intro_call", 4, "ngIf"], ["class", "mr-2 text-main", "jhiTranslate", "inukaNgApp.inukaJourney.selfScan", 4, "ngIf"], [1, "d-inline-block", "float-right", "pt-2"], [3, "click", 4, "ngIf"], [1, "text-light"], ["icon", "check"], [1, "circle-white"], ["style", "height: 14px; width: 14px;", 4, "ngIf"], ["style", "height: 10px; width: 14px;", 4, "ngIf"], [2, "height", "14px", "width", "14px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#journey-anonymous-chat"], [2, "height", "10px", "width", "14px"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#journey-video"], [0, "xlink", "href", "../../../../../../../../content/images/sprite.svg?v=3#journey-intro_call"], ["jhiTranslate", "inukaNgApp.inukaJourney.anonymousChat", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.videoCall", 1, "mr-2", "text-main"], ["jhiTranslate", "sessionSchedule.paragraph.intro_call", 1, "mr-2", "text-main"], ["jhiTranslate", "inukaNgApp.inukaJourney.selfScan", 1, "mr-2", "text-main"], [3, "click"], [3, "wellbeingResult"], ["ngbDropdown", "", "placement", "bottom-right", 1, "dropdown"], ["ngbDropdownToggle", "", "jhiTranslate", "inukaNgApp.inukaJourney.viewSession", 1, "btn-link"], ["ngbDropdownMenu", "", "aria-labelledby", "actionsMenu", 1, "dropdown-menu"], ["jhiTranslate", "inukaNgApp.inukaJourney.openInNewTab", 1, "dropdown-item", 3, "click"], ["jhiTranslate", "inukaNgApp.inukaJourney.openInThisTab", 1, "dropdown-item", "d-none", "d-lg-block", 3, "click"]], template: function InukaJourneyCoachChatComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵelementStart(0, "div", 0);
        i0.ɵɵelementStart(1, "div", 1);
        i0.ɵɵelementStart(2, "div", 2);
        i0.ɵɵelementStart(3, "div", 3);
        i0.ɵɵelementStart(4, "span", 4);
        i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_Template_span_click_4_listener() { return ctx.changeTab("all", ctx.allList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(5, "span", 5);
        i0.ɵɵtext(6, " | ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(7, "span", 6);
        i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_Template_span_click_7_listener() { return ctx.changeTab("session", ctx.sessionList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(8, "span", 5);
        i0.ɵɵtext(9, " | ");
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(10, "span", 7);
        i0.ɵɵlistener("click", function InukaJourneyCoachChatComponent_Template_span_click_10_listener() { return ctx.changeTab("scan", ctx.scanList); });
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementStart(11, "div", 8);
        i0.ɵɵelementStart(12, "table", 9);
        i0.ɵɵelementStart(13, "tbody");
        i0.ɵɵtemplate(14, InukaJourneyCoachChatComponent_tr_14_Template, 11, 4, "tr", 10);
        i0.ɵɵtemplate(15, InukaJourneyCoachChatComponent_tr_15_Template, 11, 4, "tr", 10);
        i0.ɵɵtemplate(16, InukaJourneyCoachChatComponent_tr_16_Template, 17, 15, "tr", 11);
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
        i0.ɵɵelementEnd();
    } if (rf & 2) {
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "all" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(3);
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "session" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(3);
        i0.ɵɵclassProp("font-weight-bold", ctx.selectedTab === "scan");
        i0.ɵɵproperty("ngClass", ctx.selectedTab === "scan" ? "font-weight-bold" : "disabled");
        i0.ɵɵadvance(4);
        i0.ɵɵproperty("ngIf", ctx.startedSession && ctx.selectedTab !== "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngIf", ctx.upcomingSession && ctx.selectedTab !== "scan");
        i0.ɵɵadvance(1);
        i0.ɵɵproperty("ngForOf", ctx.displayList);
    } }, directives: [i3.JhiTranslateDirective, i4.NgClass, i4.NgIf, i4.NgForOf, i5.FaIconComponent, i6.WellbeingResultBadgeComponent, i2.NgbDropdown, i2.NgbDropdownToggle, i2.NgbDropdownMenu], pipes: [i4.DatePipe], styles: [".table-responsive[_ngcontent-%COMP%]{height:100%;overflow-x:hidden}.journey-table[_ngcontent-%COMP%]{width:100%;margin-bottom:1rem}.journey-table[_ngcontent-%COMP%]   th[_ngcontent-%COMP%], .journey-table[_ngcontent-%COMP%]   td[_ngcontent-%COMP%]{vertical-align:center}.journey-table[_ngcontent-%COMP%]   thead[_ngcontent-%COMP%]   th[_ngcontent-%COMP%]{vertical-align:bottom}.journey-row-icon[_ngcontent-%COMP%]{text-align:center}.icon-connector[_ngcontent-%COMP%]{transform:rotate(90deg);width:100% !important;background-color:#44a38b;height:.2rem}.icon-connector-light[_ngcontent-%COMP%]{background-color:#cce9e0}.circle[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#44a38b;color:#fff;z-index:10;display:inline-block;margin:0}.circle-light[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#cce9e0;color:#44a38b;z-index:10;display:inline-block;margin:0}.circle-two-color[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:2rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#44a38b;color:#fff;z-index:10;display:inline-block;border:.5rem #cce9e0 solid;box-sizing:border-box;margin:0}.circle-white[_ngcontent-%COMP%]{width:2rem;height:2rem;line-height:1.5rem;border-radius:50%;text-align:center;position:relative;cursor:pointer;background-color:#fff;color:#44a38b;z-index:10;display:inline-block;border:.15rem #44a38b solid;box-sizing:border-box;margin:0}.select-tab[_ngcontent-%COMP%]{font-size:12px;font-weight:bold;padding:2px}.dropdown-menu[_ngcontent-%COMP%]{min-width:180px !important;border:none !important;border-radius:10px !important;box-shadow:-3px 0px 30px rgba(0,0,0,.15)}.dropdown-menu[_ngcontent-%COMP%]:before{z-index:10000}.dropdown-toggle[_ngcontent-%COMP%]:after{display:none}.dropdown-item[_ngcontent-%COMP%]{background-color:#fff;color:#44a38d !important}.dropdown-item[_ngcontent-%COMP%]:hover{background-color:#44a38d;color:#fff !important}"] });
